import { isDev } from "../../base/index.js";
const alphaMinMax = [0, 1];
function applyAlphaToColor(hexColor, alpha) {
  const hexCheckRegex = /^#([0-9a-f]{3}){1,2}$/i;
  if (!hexCheckRegex.test(hexColor)) {
    if (isDev()) {
      throw new Error("Invalid hex color");
    }
    return hexColor;
  }
  if (alpha < alphaMinMax[0] || alpha > alphaMinMax[1]) {
    if (isDev()) {
      throw new Error("alpha has to be in the [0, 1] interval");
    }
  }
  const opacity = Math.round(Math.min(Math.max(alpha, 0), 1) * 255);
  const hex6Digits = hexColor.length === 4 ? `#${to6Digits(hexColor.slice(1))}` : hexColor;
  return `${hex6Digits}${opacity.toString(16).toUpperCase()}`;
}
function to6Digits(hexColor) {
  return hexColor.split("").map((char) => char + char).join("");
}
export {
  applyAlphaToColor
};
//# sourceMappingURL=applyAlphaToColor.js.map
